// Keys.js
/**
 * Generates a random alphanumeric key of the specified length.
 * 
 * Uses characters A-Z, a-z, and 0-9 for maximum entropy.
 * 
 * @param {number} [length=25] - The length of the key to generate (default 25).
 * 
 * @returns {string} A random alphanumeric string.
 */
export function generateKey(length = 25) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
